<template>
  <div>
    <slot />

    <a
      :href="to"
      target="_blank"
      class="no-underline"
    >
      <slot
        v-if="mediaLoaded"
        name="ctaBannerTop"
      />

      <XLazyMedia
        :media="thumbnail"
        @mediaLoaded="emitMediaLoaded"
      />

      <slot
        v-if="mediaLoaded"
        name="ctaBannerBottom"
      />
    </a>

    <slot name="footer" />
  </div>
</template>

<script>
import Mixin from './mixin'

export default {
  mixins: [Mixin],

  props: {
    to: {
      type: String,
      default: ''
    }
  }
}
</script>
